// extracted by mini-css-extract-plugin
module.exports = {"success-inner":"success_success-inner__DG7fE","success-title":"success_success-title__3jO-v","success-info":"success_success-info__2fPnL"};